import MenuItem from './MenuItem';

import './NavigationMenu.scss';

export const NavigationMenu = ({
  isSettingsMode,
  currentNavItems,
  mini
}) => {
  return (
    <div className="nav-menu">
      <div className="nav-menu__wrapper">
        {/* Only shown collapsed - expanded, Settings lives in the footer's
            account popover (see useUserDropdown.js) matching the design.
            Collapsed still needs its own entry point since the footer's
            click-to-open-dropdown is disabled in mini mode. */}
        {!isSettingsMode && mini && (
          <>
            <MenuItem
              item={{
                menuItem: "Settings",
                path: "/settings",
                icon: { source: 'additional', name: 'Settings' },
              }}
              mini={mini}
            />
            <div className="nav-menu__divider"></div>
          </>
        )}

        {currentNavItems.length === 0 ? (
          <div className="nav-menu__empty-state">
            {!mini && "No modules available"}
          </div>
        ) : (
          currentNavItems.map((item) => (
            <MenuItem
              key={item.path || item.menuItem}
              item={item}
              mini={mini}
            />
          ))
        )}
      </div>
    </div>
  );
};
